export const buildContainerStyles = (currentTheme, isRTL) => ({
    minHeight: "100vh",
    background: currentTheme?.background?.gradient || "linear-gradient(135deg, #66ea9fff 0%, #764ba2 100%)",
    fontFamily: currentTheme?.fonts?.primary || "Arial, sans-serif",
    position: "relative",
    overflow: "hidden",
    transition: "all 0.3s ease",
    direction: isRTL ? "rtl" : "ltr", // ✅ اتجاه الصفحة
});

export const buildGlobalStyles = (currentTheme, isRTL, sidebarOpen) => `
  * { 
    box-sizing: border-box; 
  }
  
  body {
    margin: 0;
    padding: 0;
    font-family: ${isRTL ? "'Cairo', 'Tajawal', " : ""}${currentTheme?.fonts?.primary || "Arial, sans-serif"};
  }
  
  input::placeholder { 
    color: ${currentTheme?.colors?.textSecondary || "#666"}; 
  }
  
  ::-webkit-scrollbar { 
    width: 8px; 
  }
  
  ::-webkit-scrollbar-track { 
    background: ${currentTheme?.colors?.scrollbar?.track || "#f1f1f1"}; 
    border-radius: 4px; 
  }
  
  ::-webkit-scrollbar-thumb { 
    background: ${currentTheme?.colors?.scrollbar?.thumb || "#c1c1c1"}; 
    border-radius: 4px; 
  }
  
  ::-webkit-scrollbar-thumb:hover { 
    background: ${currentTheme?.colors?.scrollbar?.thumbHover || "#a8a8a8"}; 
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .mo3ti-sidebar { 
      width: 100% !important; 
      ${isRTL ? 'right' : 'left'}: ${sidebarOpen ? "0" : "-100%"} !important; 
      z-index: 1000;
    }
    
    .mo3ti-main { 
      ${isRTL ? 'margin-right' : 'margin-left'}: 0 !important; 
    }
    
    .mo3ti-topbar { 
      padding: 12px 16px !important; 
    }
    
    .mo3ti-content { 
      padding: 20px 16px !important; 
    }
    
    .mo3ti-search { 
      width: 200px !important; 
    }
  }
  
  @media (max-width: 480px) {
    .mo3ti-content { 
      padding: 16px 12px !important; 
    }
    
    .mo3ti-search { 
      width: 150px !important; 
    }
  }
`;